module.exports = __webpack_public_path__ + "img/ew-icon_undecided.31b60856.svg";